/** Cadrage en fractions de l'image source (appliqué serveur par sharp). */
export interface CropFraction { x: number; y: number; size: number }

/** Chemin d'upload avec cadrage optionnel en query string. */
export function uploadPath(base: string, crop?: CropFraction | null): string {
  if (!crop) return base
  const p = new URLSearchParams({
    crop_x: crop.x.toFixed(5), crop_y: crop.y.toFixed(5), crop_size: crop.size.toFixed(5),
  })
  return `${base}?${p}`
}
